export enum LoggerNoiseReportParametersControlKey {
  Map = 'map',
  StreetView = 'streetView',
  Histogram = 'histogram',
  SignalSpectrum = 'signalSpectrum',
  LeakScoreHistory = 'leakScoreHistory',
  NoiseLevelHistory = 'noiseLevelHistory',
}
